const ACTIVE_COLOR = '#4F6B2C';

export const styles = {
    content: {
        display: 'inline-flex',
        alignItems: 'stretch',
        border: '2px solid #fff',
        borderRadius: 4,
        overflow: 'hidden',
        userSelect: 'none',
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        minWidth: 48,
        padding: '10px 14px',
        color: '#fff',
        fontFamily: 'Montserrat',
        fontSize: 18,
        fontWeight: '100',
        letterSpacing: 1,
        textTransform: 'uppercase',
        backgroundColor: 'transparent',
        cursor: 'pointer',
    },
    optionActive: {
        backgroundColor: ACTIVE_COLOR,
    },
    divider: {
        width: 2,
        backgroundColor: '#fff',
    },
    flag: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0,
        display: 'block',
    },
};
